import { CountryEnum } from "@/types";

export const COUNTRY_LABELS: Record<CountryEnum, string> = {
  [CountryEnum.IN]: "India",
  [CountryEnum.US]: "United States",
  [CountryEnum.UK]: "United Kingdom",
};

export const countryOptions = Object.values(CountryEnum).map((value) => ({
  value,
  label: COUNTRY_LABELS[value],
}));

export function formatCountry(country?: CountryEnum | string): string {
  if (!country) return "";
  const normalized = country as CountryEnum;
  return COUNTRY_LABELS[normalized] || normalized;
}
